import React from "react"

import { Video } from "../components/video"

export const components = {
  Video: props => <Video noshadow className="mt-6 mb-12 shadow-md" {...props} />,
  a: props => <a className="text-blue-500 hover:text-blue-600" {...props} />,
  h1: props => <h1 className="text-3xl font-extrabold mt-12 text-gray-900" {...props} />,
  h2: props => <h2 className="text-2xl font-bold mt-10 text-gray-800 group" {...props} />,
  h3: props => <h3 className="text-lg font-bold mt-10 text-gray-800 group" {...props} />,
  p: props => <p className="text-lg mt-4" {...props}></p>,
  ul: props => <ul className="mt-3 list-disc" {...props}></ul>,
  ol: props => <ol className="mt-3 list-decimal" {...props}></ol>,
  li: props => <li className="ml-8" {...props}></li>,
  hr: props => <hr className="my-8 border-t-2" {...props}></hr>,
  strong: props => <b className="font-bold text-gray-600" {...props}></b>,
  em: props => <span className="text-base font-bold bg-gray-100 p-1 rounded" {...props} />,
  cap: props => <span className="text-gray-500" {...props} />
}